var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_4956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50599 6.71979C6.80054 6.71979 7.03932 6.95857 7.03932 7.25313V11.7331C7.03932 12.0277 6.80054 12.2665 6.50599 12.2665C6.21144 12.2665 5.97266 12.0277 5.97266 11.7331V7.25313C5.97266 6.95857 6.21144 6.71979 6.50599 6.71979Z",
    fill: "#330072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.026 7.25313C10.026 6.95857 9.78726 6.71979 9.49271 6.71979C9.19816 6.71979 8.95937 6.95857 8.95937 7.25313V11.7331C8.95937 12.0277 9.19816 12.2665 9.49271 12.2665C9.78726 12.2665 10.026 12.0277 10.026 11.7331V7.25313Z",
    fill: "#330072"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47932 2.98646V2.02667C4.47932 1.48916 4.69285 0.97367 5.07292 0.593597C5.45299 0.213523 5.96848 0 6.50599 0H9.49265C10.0302 0 10.5457 0.213523 10.9257 0.593597C11.3058 0.97367 11.5193 1.48916 11.5193 2.02667V2.98646H14.7194C15.014 2.98646 15.2528 3.22524 15.2528 3.51979C15.2528 3.81434 15.014 4.05313 14.7194 4.05313H13.7593V13.9733C13.7593 14.5108 13.5458 15.0263 13.1657 15.4064C12.7857 15.7865 12.2702 16 11.7327 16H4.26599C3.72848 16 3.21299 15.7865 2.83292 15.4064C2.45285 15.0263 2.23932 14.5108 2.23932 13.9733V4.05313H1.27943C0.984875 4.05313 0.746094 3.81434 0.746094 3.51979C0.746094 3.22524 0.984875 2.98646 1.27943 2.98646H4.47932ZM5.82717 1.34784C6.0072 1.16781 6.25138 1.06667 6.50599 1.06667H9.49265C9.74726 1.06667 9.99144 1.16781 10.1715 1.34784C10.3515 1.52788 10.4527 1.77206 10.4527 2.02667V2.98646H5.54599V2.02667C5.54599 1.77206 5.64713 1.52788 5.82717 1.34784ZM3.30599 13.9733V4.05333H12.6927V13.9733C12.6927 14.2279 12.5915 14.4721 12.4115 14.6522C12.2314 14.8322 11.9873 14.9333 11.7327 14.9333H4.26599C4.01138 14.9333 3.7672 14.8322 3.58717 14.6522C3.40713 14.4721 3.30599 14.2279 3.30599 13.9733Z",
    fill: "#330072"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_4956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a3a5c10b6174c4657071c3a19bac2b79.svg";
export { ForwardRef as ReactComponent };